export default __webpack_public_path__ + "static/michael-b1dd750784897ebc9097708fe0d22ab8.png";